/* ==========================================================
   ADHEK PERÚ - REGLAS CENTRALES DE ENVÍO
   ==========================================================

   Fuente única para:
   - clasificación de destinos
   - envío gratis
   - envío regular
   - express
   - fechas de entrega
   - domingos y feriados
   - cortes horarios

   IMPORTANTE:
   Todos los importes están expresados en céntimos.
   ========================================================== */

(function(window) {
  'use strict';

  var CONFIG = {

    // ----------------------------
    // IMPORTES
    // ----------------------------

    freeShippingThreshold: 9900, // S/99

regularPrice: 1500,          // S/15 Lima / Callao / Lima Courier
provinceRegularPrice: 1800,  // S/18 resto del Perú

expressPrice: 2500,          // S/25

    // ----------------------------
    // HORAS DE CORTE
    // ----------------------------

    regularCutoffHour: 20,       // 8:00 p. m.
    freeCutoffHour: 16,          // 4:00 p. m.

    // ----------------------------
    // ENVÍO GRATIS
    // ----------------------------

    // JavaScript:
    // Domingo = 0
    // Lunes   = 1
    // Martes  = 2
    // Miércoles = 3
    // Jueves  = 4
    // Viernes = 5
    // Sábado  = 6

    freeDeliveryDays: [3, 6],

    // ----------------------------
    // COURIER
    // ----------------------------

    // Tiempo estimado luego de entregar
    // el paquete al operador logístico.

    courierTransitMinDays: 1,
    courierTransitMaxDays: 2
  };


  /* ==========================================================
     NORMALIZACIÓN
     ========================================================== */

  function normalize(text) {

    return String(text || '')
      .trim()
      .toUpperCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  }


  /* ==========================================================
     DISTRITOS LIMA / CALLAO QUE SE TRATAN COMO COURIER
     ========================================================== */

  var LIMA_COURIER_DISTRICTS = [

    'ANCON',
    'ATE',
    'CARABAYLLO',
    'CHACLACAYO',
    'CIENEGUILLA',
    'HUAYCAN',
    'HUACHIPA',
    'LURIGANCHO',
    'LURIN',
    'PACHACAMAC',
    'PUCUSANA',
    'PUENTE PIEDRA',
    'PUNTA HERMOSA',
    'PUNTA NEGRA',
    'SAN BARTOLO',
    'SANTA MARIA DEL MAR',
    'SANTA ROSA',
    'VENTANILLA',
    'MI PERU',
    'VILLA EL SALVADOR'

  ].map(normalize);


  /* ==========================================================
     CLASIFICACIÓN DEL DESTINO
     ========================================================== */

  function classifyDestination(destination) {

    destination = destination || {};

    var department = normalize(
      destination.department ||
      destination.departamento
    );

    var province = normalize(
      destination.province ||
      destination.provincia
    );

    var district = normalize(
      destination.district ||
      destination.distrito
    );


    /* ----------------------------
       CALLAO
       ---------------------------- */

    if (department === 'CALLAO') {

      if (
        LIMA_COURIER_DISTRICTS.indexOf(district) !== -1
      ) {
        return 'LIMA_COURIER';
      }

      return 'LIMA_LOCAL';
    }


    /* ----------------------------
       DEPARTAMENTO DE LIMA
       ---------------------------- */

    if (department === 'LIMA') {

      // Cualquier provincia de Lima distinta
      // a la provincia Lima se atiende por courier.
      //
      // Ejemplo:
      // Huaral
      // Cañete
      // Huaura
      // Barranca
      // Yauyos
      // etc.

      if (province && province !== 'LIMA') {
        return 'LIMA_COURIER';
      }


      // Provincia Lima, pero distrito que
      // operativamente debe ir por courier.

      if (
        LIMA_COURIER_DISTRICTS.indexOf(district) !== -1
      ) {
        return 'LIMA_COURIER';
      }


      return 'LIMA_LOCAL';
    }


    /* ----------------------------
       RESTO DEL PERÚ
       ---------------------------- */

    return 'PROVINCIAS_PERU';
  }


  /* ==========================================================
     ENVÍO GRATIS
     ========================================================== */

  function destinationHasFreeShipping(destination) {

    var zone = classifyDestination(destination);

    return (
      zone === 'LIMA_LOCAL' ||
      zone === 'LIMA_COURIER'
    );

  }


  function qualifiesForFreeShipping(
    destination,
    merchandiseTotal
  ) {

    return (
      destinationHasFreeShipping(destination) &&
      Number(merchandiseTotal || 0) >= CONFIG.freeShippingThreshold
    );

  }


  /* ==========================================================
     EXPRESS
     ========================================================== */

  function isExpressEligible(destination) {

    /*
      Por ahora Express queda habilitado únicamente
      para LIMA_LOCAL.

      Los destinos LIMA_COURIER y PROVINCIAS_PERU
      quedan excluidos.
    */

    return classifyDestination(destination) === 'LIMA_LOCAL';

  }


  /* ==========================================================
     FORMATO DE DINERO
     ========================================================== */

  function money(cents) {

    cents = Number(cents || 0);

    return 'S/' + (cents / 100).toFixed(2);

  }


  /* ==========================================================
     FECHAS
     ========================================================== */

  function cloneDate(date) {

    return new Date(date.getTime());

  }


  function startOfDay(date) {

    var result = cloneDate(date);

    result.setHours(0, 0, 0, 0);

    return result;

  }


  function addCalendarDays(date, amount) {

    var result = cloneDate(date);

    result.setDate(result.getDate() + amount);

    return result;

  }


  /* ==========================================================
     CÁLCULO DE SEMANA SANTA
     ========================================================== */

  function easterSunday(year) {

    // Algoritmo gregoriano de Meeus/Jones/Butcher

    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);

    var month = Math.floor(
      (h + l - 7 * m + 114) / 31
    );

    var day =
      ((h + l - 7 * m + 114) % 31) + 1;

    return new Date(year, month - 1, day);

  }


  /* ==========================================================
     FERIADOS NACIONALES PERÚ
     ========================================================== */

  function getPeruHolidays(year) {

    var dates = [

      year + '-01-01', // Año Nuevo
      year + '-05-01', // Día del Trabajo
      year + '-06-07',
      year + '-06-29',
      year + '-07-23',
      year + '-07-28',
      year + '-07-29',
      year + '-08-06',
      year + '-08-30',
      year + '-10-08',
      year + '-11-01',
      year + '-12-08',
      year + '-12-09',
      year + '-12-25'

    ];

    var easter = easterSunday(year);

    // Jueves Santo
    var holyThursday = addCalendarDays(easter, -3);

    // Viernes Santo
    var goodFriday = addCalendarDays(easter, -2);

    dates.push(dateKey(holyThursday));
    dates.push(dateKey(goodFriday));

    return dates;

  }


  function pad(number) {

    return String(number).padStart(2, '0');

  }


  function dateKey(date) {

    return (
      date.getFullYear() +
      '-' +
      pad(date.getMonth() + 1) +
      '-' +
      pad(date.getDate())
    );

  }


  function isHoliday(date) {

    var holidays = getPeruHolidays(
      date.getFullYear()
    );

    return holidays.indexOf(dateKey(date)) !== -1;

  }


  function isSunday(date) {

    return date.getDay() === 0;

  }


  function isOperationalDay(date) {

    return (
      !isSunday(date) &&
      !isHoliday(date)
    );

  }


  /* ==========================================================
     SIGUIENTE DÍA OPERATIVO
     ========================================================== */

  function nextOperationalDay(date) {

    var candidate = addCalendarDays(
      startOfDay(date),
      1
    );

    while (!isOperationalDay(candidate)) {

      candidate = addCalendarDays(
        candidate,
        1
      );

    }

    return candidate;

  }


  /* ==========================================================
     REGULAR LOCAL - S/15
     ==========================================================

     Antes o hasta las 8 p. m.:
     entrega siguiente día operativo.

     Después de las 8 p. m.:
     se procesa siguiente día operativo y
     entrega al siguiente día operativo.
     ========================================================== */

  function getRegularLocalDeliveryDate(now) {

    now = now ? new Date(now) : new Date();

    var operationalToday = isOperationalDay(now);

    var afterCutoff =
  now.getHours() > CONFIG.regularCutoffHour ||
  (
    now.getHours() === CONFIG.regularCutoffHour &&
    now.getMinutes() > 0
  );


    /*
      Domingo o feriado:

      se considera que entra para procesamiento
      el siguiente día operativo y se entrega
      al día operativo posterior.
    */

    if (!operationalToday) {

      var processingDay =
        nextOperationalDay(now);

      return nextOperationalDay(
        processingDay
      );

    }


    /*
      Día operativo antes de las 8 p. m.
    */

    if (!afterCutoff) {

      return nextOperationalDay(now);

    }


    /*
      Día operativo después de las 8 p. m.
    */

    var nextProcessingDay =
      nextOperationalDay(now);

    return nextOperationalDay(
      nextProcessingDay
    );

  }


  /* ==========================================================
     ENVÍO GRATIS - MIÉRCOLES / SÁBADO
     CORTE: 4 P. M. DEL DÍA ANTERIOR
     ========================================================== */

  function getNextFreeDeliveryDate(now) {

    now = now ? new Date(now) : new Date();

    /*
      Si el pedido entra domingo o feriado,
      para efectos operativos comienza a contarse
      desde el siguiente día operativo.
    */

    var effectiveNow = new Date(now);

    if (!isOperationalDay(effectiveNow)) {

      effectiveNow =
        nextOperationalDay(effectiveNow);

      effectiveNow.setHours(0, 0, 0, 0);

    }


    /*
      Revisamos las próximas fechas posibles.
    */

    for (var offset = 1; offset <= 21; offset++) {

      var candidate =
        addCalendarDays(
          startOfDay(effectiveNow),
          offset
        );


      if (
        CONFIG.freeDeliveryDays.indexOf(
          candidate.getDay()
        ) === -1
      ) {
        continue;
      }


      // Si miércoles o sábado es feriado,
      // no se utiliza.

      if (!isOperationalDay(candidate)) {
        continue;
      }


      /*
        Corte = día anterior a las 4:00 p. m.
      */

      var cutoff =
        addCalendarDays(candidate, -1);

      cutoff.setHours(
        CONFIG.freeCutoffHour,
        0,
        0,
        0
      );


      if (effectiveNow <= cutoff) {
        return candidate;
      }

    }


    return null;

  }


  /* ==========================================================
     COURIER - RANGO DE ARRIBO
     ========================================================== */

  function addOperationalDays(date, amount) {

    var result = startOfDay(date);
    var added = 0;

    while (added < amount) {

      result =
        addCalendarDays(result, 1);

      if (isOperationalDay(result)) {
        added++;
      }

    }

    return result;

  }


  function getCourierArrivalRange(dispatchDate) {

    if (!dispatchDate) {
      return null;
    }

    return {

      min: addOperationalDays(
        dispatchDate,
        CONFIG.courierTransitMinDays
      ),

      max: addOperationalDays(
        dispatchDate,
        CONFIG.courierTransitMaxDays
      )

    };

  }


  /* ==========================================================
     FORMATO DE FECHA EN ESPAÑOL
     ========================================================== */

  function formatDate(date) {

    if (!date) {
      return '';
    }

    return date.toLocaleDateString(
      'es-PE',
      {
        weekday: 'long',
        day: 'numeric',
        month: 'long'
      }
    );

  }


  /* ==========================================================
     MONTO RESTANTE PARA ENVÍO GRATIS
     ========================================================== */

  function getRemainingForFreeShipping(total) {

    total = Number(total || 0);

    return Math.max(
      CONFIG.freeShippingThreshold - total,
      0
    );

  }


  /* ==========================================================
     API PÚBLICA
     ========================================================== */

  window.AdhekShippingRules = {

    config: CONFIG,

    normalize: normalize,

    classifyDestination: classifyDestination,

    destinationHasFreeShipping:
      destinationHasFreeShipping,

    qualifiesForFreeShipping:
      qualifiesForFreeShipping,

    isExpressEligible:
      isExpressEligible,

    getRemainingForFreeShipping:
      getRemainingForFreeShipping,

    getRegularLocalDeliveryDate:
      getRegularLocalDeliveryDate,

    getNextFreeDeliveryDate:
      getNextFreeDeliveryDate,

    getCourierArrivalRange:
      getCourierArrivalRange,

    addOperationalDays:
      addOperationalDays,

    isOperationalDay:
      isOperationalDay,

    isHoliday:
      isHoliday,

    formatDate:
      formatDate,

    money:
      money

  };

})(window);